 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"9cd9d4041ee164829bbb02bb037c057e73016f1d","3":"d15354cb086842c491f4ecc0a2a534a23ff4b0ff","4":"45d6c33ab4e0634974abeff92615c93bf42a39b1","5":"8226f16a5cd16cd0cd43ba5a147fbe521f6d115d","6":"bfb0fa5ec7e51aaabb46a076c43c811ba734e3fe","7":"99be79b2d9ec1bed67829a329182cc178d3c5069","8":"e36180cb0375aaa6b1636939bd769b257a64c0c3","9":"7284c81c6a95731c9a34a0dd5f59236bd2238816","12":"component---src-pages-404-js","13":"component---src-pages-about-index-js","14":"component---src-pages-canopy-index-js","15":"component---src-pages-extension-index-js","16":"component---src-pages-hong-x-panasonic-index-js","17":"component---src-pages-index-js","18":"component---src-pages-press-index-js","19":"component---src-pages-the-question-index-js","20":"component---src-pages-tung-chung-prize-index-js","21":"component---src-templates-about-page-template-review-js","22":"component---src-templates-artwork-list-c-template-js","23":"component---src-templates-artwork-list-h-template-js","24":"component---src-templates-press-image-template-js","25":"component---src-templates-project-e-template-js","26":"component---src-templates-project-e-template-review-js","27":"component---src-templates-project-list-e-template-js","28":"component---src-templates-project-list-q-template-js","29":"component---src-templates-project-list-t-template-js","30":"component---src-templates-project-q-template-js","31":"component---src-templates-project-q-template-review-js","32":"component---src-templates-project-t-template-js","33":"component---src-templates-project-t-template-review-js"}[chunkId]||chunkId) + "-" + {"0":"2db048ce9867a9ad2fe3","1":"e9d24b1846c7d6eb9685","2":"b9ddcf582353a96d9c56","3":"7dcb9feaba0e36995cb3","4":"9d152579d31994f68a8d","5":"8fb2bec181c073c0498a","6":"c4a2b55bad2184788049","7":"1c5747b226c2673ae0fe","8":"571f70cf31a6b5b773a5","9":"edf8730b7f45f1e3667e","12":"6eb83385aa5c618371b5","13":"80ba5d7227fa8f7c72a6","14":"0da5dde6998c1e621567","15":"0f66bb9855c4e05d885e","16":"b0c9098f3d0f9e0bfa72","17":"c1f2fc52d90c73d8ac65","18":"91762ed39c4d5efcea29","19":"772506bb9c6c91a0af40","20":"a37876a9ae15243c4695","21":"757fe0286d140ea6b5d6","22":"d728d659c48e87081cfc","23":"34fe18f521b569e11f45","24":"bb51915c2fce77b1b465","25":"9633c4883433c66790fb","26":"d785a8cc99a94a1fc444","27":"686b292ca9335c122ee5","28":"01ff941dff8d2df1e53c","29":"b31282e8bda8aea4483f","30":"cbfe5bb3cbabcf799734","31":"dfb4baf6fee3e58cd70b","32":"8965957f3c46d3abe496","33":"76888d429122cdf3b1ec"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"9cd9d4041ee164829bbb02bb037c057e73016f1d","3":"d15354cb086842c491f4ecc0a2a534a23ff4b0ff","4":"45d6c33ab4e0634974abeff92615c93bf42a39b1","5":"8226f16a5cd16cd0cd43ba5a147fbe521f6d115d","6":"bfb0fa5ec7e51aaabb46a076c43c811ba734e3fe","7":"99be79b2d9ec1bed67829a329182cc178d3c5069","8":"e36180cb0375aaa6b1636939bd769b257a64c0c3","9":"7284c81c6a95731c9a34a0dd5f59236bd2238816","12":"component---src-pages-404-js","13":"component---src-pages-about-index-js","14":"component---src-pages-canopy-index-js","15":"component---src-pages-extension-index-js","16":"component---src-pages-hong-x-panasonic-index-js","17":"component---src-pages-index-js","18":"component---src-pages-press-index-js","19":"component---src-pages-the-question-index-js","20":"component---src-pages-tung-chung-prize-index-js","21":"component---src-templates-about-page-template-review-js","22":"component---src-templates-artwork-list-c-template-js","23":"component---src-templates-artwork-list-h-template-js","24":"component---src-templates-press-image-template-js","25":"component---src-templates-project-e-template-js","26":"component---src-templates-project-e-template-review-js","27":"component---src-templates-project-list-e-template-js","28":"component---src-templates-project-list-q-template-js","29":"component---src-templates-project-list-t-template-js","30":"component---src-templates-project-q-template-js","31":"component---src-templates-project-q-template-review-js","32":"component---src-templates-project-t-template-js","33":"component---src-templates-project-t-template-review-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"be61079c962a455a62bc","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
